

export default function Facilites() {
  return (
    <div>
        this is facilities
    </div>
  )
}